module.exports = __webpack_public_path__ + "static/media/15_1.4631b47d.jpg";